import {
  ApiRequest,
  GetBaseServiceFunctions,
  queryClient,
} from '../baseService'

const BaseRoute = 'app/clients'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

function CheckDuplicateEmail(params) {
  return ApiRequest.get(`${BaseRoute}/similarItemsByEmail`, {
    params,
  })
}

function CheckDuplicateLastName(params) {
  return ApiRequest.get(`${BaseRoute}/similarItemsByLastName`, {
    params,
  })
}

function CheckDuplicateFullName(params) {
  return ApiRequest.get(`${BaseRoute}/similarItemsByFullName`, {
    params,
  })
}

function AssessmentHistory(params) {
  return ApiRequest.get(`${BaseRoute}/getCaseByClient`, {
    params,
  })
}

function Enable(id) {
  queryClient.invalidateQueries([BaseRoute, id])
  return ApiRequest.put(`${BaseRoute}/${id}/enable`)
}

function Disable(id) {
  queryClient.invalidateQueries([BaseRoute, id])
  return ApiRequest.put(`${BaseRoute}/${id}/disable`)
}

function ExportSearchResult(payload = {}) {
  return ApiRequest.post(`${BaseRoute}/export`, payload, {
    responseType: 'arraybuffer',
  })
}
function DownloadUploadClientTemplate() {
  return ApiRequest.post(
    `${BaseRoute}/template-import`,
    {},
    { responseType: 'arraybuffer' }
  )
}
function UploadFiles(file) {
  return ApiRequest.post(`${BaseRoute}/import`, file)
}

// Dry-run: validate the uploaded file and get a per-row preview without writing anything.
function PreviewImport(file) {
  return ApiRequest.post(`${BaseRoute}/preview-import`, file)
}

// Real import. skipInvalidRows=true imports every valid/warning row and reports the rest;
// false aborts the whole import if any row is invalid.
// maxItem/startFrom import only one slice of the file (sequential batching): the backend
// re-parses the uploaded file and imports rows [startFrom, startFrom + maxItem) only.
// maxItem <= 0 imports the whole file in a single request (legacy behaviour).
function ImportClients(
  file,
  skipInvalidRows = true,
  maxItem = 0,
  startFrom = 0
) {
  const query = [`skipInvalidRows=${skipInvalidRows}`]
  if (maxItem > 0) {
    query.push(`maxItem=${maxItem}`, `startFrom=${startFrom}`)
  }
  return ApiRequest.post(`${BaseRoute}/import?${query.join('&')}`, file)
}

function GetBookingHistory(params = {}) {
  return ApiRequest.get(`${BaseRoute}/bookingHistory`, {
    params,
  })
}
const API = {
  ...baseFunctions,
  CheckDuplicateEmail,
  CheckDuplicateLastName,
  CheckDuplicateFullName,
  AssessmentHistory,
  Enable,
  Disable,
  ExportSearchResult,
  DownloadUploadClientTemplate,
  UploadFiles,
  PreviewImport,
  ImportClients,
  GetBookingHistory,
}

export default API
